import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { dialogId: String };

  close() {
    document.getElementById(this.dialogIdValue).close();
  }

  open() {
    document.getElementById(this.dialogIdValue).showModal();
  }
}
